import React from "react";
import cx from "classnames";

import "./style.scss";

const CoinInterestRateCard = ({
  classNames,
  imgSrc,
  imgHeight,
  imgWidth,
  rate,
  annualPercentageYieldLabel,
  apyLabel,
  ...rest
}) => {
  return (
    <div
      className={cx("coin-interest-rate-card card card-body", classNames)}
      {...rest}
    >
      <div>
        <img
          src={imgSrc}
          alt="Coin Icon"
          className="img-fluid mb-3"
          height={imgHeight}
          width={imgWidth}
          loading="eager"
        />
      </div>
      <span className="rate">{rate}</span>
      <p className="mt-2 mb-0">
        {annualPercentageYieldLabel} <br />
        <span>{apyLabel}</span>
      </p>
    </div>
  );
};

export default CoinInterestRateCard;
